module.exports = __webpack_public_path__ + "img/VG.0fd099f9.svg";